import AuthLayout from "./layout";
import ResetPasswordForm from "@components/auth/reset-password-form";
import { LOGIN_PAGE_ROUTE } from "@pma/utils/page-routes";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const ResetPasswordPage = () => {
  const resetParam = useSearchParams()[0].get("key");
  const navigate = useNavigate();

  useEffect(() => {
    if (!resetParam) {
      navigate(LOGIN_PAGE_ROUTE);
    }
  }, []);

  // Reset password
  if (resetParam) {
    return (
      <AuthLayout>
        <ResetPasswordForm inviteKey={resetParam} />
      </AuthLayout>
    );
  }
};

export default ResetPasswordPage;
